import {createStyles} from '@material-ui/core'

const fileDropzoneStyle = () =>
  createStyles({
    container: {
      width: '100%',
      borderRadius: 12,
      border: '2px dashed #ccc',
      background: '#f1f1f1',
      height: 200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    containerHasFiles: {
      cursor: 'default',
    },
    activeContainer: {
      borderColor: '#0cc7c7',
    },
    fileContainer: {
      background: 'white',
      padding: 10,
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      borderRadius: 12,
    },
    fileName: {
      fontSize: 14,
      fontWeight: 500,
      color: 'black',
    },
  })

export default fileDropzoneStyle
